import React from 'react';

export default function F2FCTA() {
  return (
    <section className="f2f-final-cta">
      <div className="f2f-final-cta-rule" aria-hidden="true" />
      <div className="wrap f2f-final-cta-inner">
        <h2 className="f2f-final-cta-heading">Don't figure it out the hard way.</h2>
        <p className="f2f-final-cta-sub">
          Four hours now to save yourself two years of guessing. Come with questions, leave with a plan.
        </p>
        <div>
          <a className="f2f-payu-link" href="https://u.payu.in/zIrP02aOwb0c">
            Book Now
          </a>
        </div>
      </div>
    </section>
  );
}

